import { render } from "./IconCalendar.vue?vue&type=template&id=5e194e0c"
const script = {}

import exportComponent from "/var/www/metiznew/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__